export default __webpack_public_path__ + "static/media/notepad.882508ea.jpg";